import localforage from 'localforage'

localforage.setDriver([localforage.LOCALSTORAGE, localforage.INDEXEDDB])

localforage.ready().catch(() => {})

export default localforage
